export var Fields;
(function (Fields) {
    Fields["TEXT"] = "text";
    Fields["PASSWORD"] = "password";
    Fields["SELECT"] = "select";
    Fields["TEXTAREA"] = "textarea";
    Fields["NUMBER"] = "number";
    Fields["EMAIL"] = "email";
    Fields["PHONE"] = "tel";
    Fields["DATE"] = "date";
    Fields["TIME"] = "time";
    Fields["RADIO_GROUP"] = "radios";
    Fields["CHECKBOX_GROUP"] = "checkboxes";
    Fields["RANGE"] = "range";
    Fields["FILE"] = "file";
    Fields["TOGGLE"] = "toggle";
    Fields["AVERAGE"] = "average";
    Fields["OTHER"] = "autre";
    Fields["PARTICIPANT"] = "participant";
    Fields["URL"] = "url";
})(Fields || (Fields = {}));
